<template lang='pug'>
div#page-container.enable-page-overlay.side-scroll.main-content-narrow
  main#main-container
    div.bg-image(style="background-image: url('./assets/bg_dashboard.jpg');")
      div.bg-primary
        div.content
          div.py-md-0.text-center.text-md-left.js-appear-enabled.animated.fadeIn(data-toggle='appear')
            h1
              span.font-size-h2.mb-2.text-white Prediction for a target phenotype for recombinant human thrombomodulin therapy in patients with sepsis
    div.content
      div.row
        div.col-lg-6
          div.block.block-rounded.block-bordered
            div.block-content
              form
                div.form-row
                  div.form-group.col-md-3
                    label PLT [X10^4/μL]
                    div.input-group.mb-2
                      input.form-control(type="number", step="0.01",v-model='exams.plt', v-on:blur="onExamUpdated")
                      //- div.input-group-append
                      //-   div.input-group-text
                  div.form-group.col-md-3
                    label PT-INR
                    div.input-group.mb-2
                      input.form-control(type="number", step="0.01", v-model='exams.pt', v-on:blur="onExamUpdated")
                      //- div.input-group-append
                      //-   div.input-group-text sec
                  div.form-group.col-md-3
                    label Fib [mg/dL]
                    div.input-group.mb-2
                      input.form-control(type="number", step="0.01", v-model='exams.fib', v-on:blur="onExamUpdated")
                  div.form-group.col-md-3
                    label FDP [μg/mL]
                    div.input-group.mb-2
                      input.form-control(type="number",step="0.01", v-model='exams.fdp', v-on:blur="onExamUpdated")
                      //- div.input-group-append
                      //-   div.input-group-text
                  div.form-group.col-md-3
                    label D-Dimer [μg/mL]
                    div.input-group.mb-2
                      input.form-control(type="number",step="0.01", v-model='exams.ddimer', v-on:blur="onExamUpdated")
                      //- div.input-group-append
                      //-   div.input-group-text

                  div.form-group.col-md-2.text-bottom
                    label(style='color: transparent;') Predict
                    div.btn.btn-sm.btn-success(style='width: 100px;', v-on:click='onClickPredict')
                      i.fa.fa-check
                      | Predict

        div.col-lg-6
          div.block.block-rounded.block-bordered.block-themed.mb-2(v-bind:class='isLoading ? `block-mode-loading` : ``', v-if='alertMessage')
            div.block-header.bg-danger-lighter
              h3.block-title.text-danger Request Error
            div.block-content
              h5 {{ alertMessage }}

          div.block.block-rounded.block-bordered.block-themed.mb-2(v-bind:class='isLoading ? `block-mode-loading` : ``')
            div.block-header.bg-xmodern-light
              h3.block-title Prediction Result
            div.block-content
              table.table.table-sm.table-bordered.table-vcenter(v-if='result')
                thead.thead-light
                  tr
                    th.text-center Result
                tbody
                  tr
                    th.text-center  {{resultMessage }}
  footer#page-footer.bg-body-light
    div.content.py-0
      div.row.font-size-sm
        div.col-sm-6.order-sm-2.mb-1.mb-sm-0.text-center.text-sm-right
        div.col-sm-6.order-sm-1.text-center.text-sm-left
</template>

<script>
import Axios from 'axios'

export default {
  name: 'App',
  data () {
    return {
      axios: Axios.create({
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      lineCount: 0,
      isLoading: false,
      exams: {
        plt: '',
        pt: '',
        fdp: '',
        fib: '',
        ddimer: ''
      },
      alertMessage: null,
      resultMessage: null,
      result: null
    }
  },
  mounted () {
    // this.asyncExtractWords(this.ehr, this.exams)
  },
  methods: {
    onExamUpdated (evt) {
      this.asyncExtractWords(this.exams)
    },
    onClickPredict (item) {
      this.asyncExtractWords(this.exams)
    },
    asyncExtractWords (exams) {
      this.isLoading = true
      // eslint-disable-next-line no-console
      console.log(exams)
      if (exams['plt'] !== '' && exams['pt'] !== '' && exams['fdp'] !== '' && exams['fib'] !== '' && exams['ddimer'] !== '') {
        this.axios('http://ec2-54-238-20-2.ap-northeast-1.compute.amazonaws.com:8000/predict', { method: 'post',
          data: { plt: exams['plt'], pt: exams['pt'], fdp: exams['fdp'], fib: exams['fib'], ddimer: exams['ddimer'] } }).then((response) => {
        // eslint-disable-next-line no-console
          console.log(exams)
          this.isLoading = false
          this.result = response.data
          this.alertMessage = null
          if (this.result) {
            if (this.result[0] === 'No') { this.resultMessage = 'non-target' } else if (
              this.result[0] === 'Yes') { this.resultMessage = 'target' }
          } else {
            this.resultMessage = 'non-target'
          }

        // this.$nextTick(() => {
        //   window.Dashmix.init()
        // })
        }).catch(err => {
          this.alertMessage = err
          this.alertMessage = 'Error'
          this.isLoading = false
        })
      } else {
        this.alertMessage = 'Fill in all variables'
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang='stylus'>
.block-header {
  padding: .10rem 1.25rem;
}
.block-content {
  padding: .50rem;
}
.table {
  margin-bottom: 0rem;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

</style>
